export const OVERALL = 'overall';
export const SKIN = 'skin';
export const HAIR = 'hair';
export const FRAGRANCE = 'fragrance';
export const PRODUCTS = 'products';
export const SCALP = 'scalp';
